import { render, staticRenderFns } from "./newPassword.vue?vue&type=template&id=15ea3ce3&"
import script from "./newPassword.vue?vue&type=script&lang=js&"
export * from "./newPassword.vue?vue&type=script&lang=js&"
import style0 from "./newPassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "newPassword.vue"
export default component.exports